import { render, staticRenderFns } from "./WaterQualityGuideline.vue?vue&type=template&id=583a2953"
import script from "./WaterQualityGuideline.vue?vue&type=script&lang=js"
export * from "./WaterQualityGuideline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports